var _rect, _ellipse, _path, _ellipse2, _ellipse3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 88,
    viewBox: "0 0 81 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 88,
    rx: 32,
    fill: "#4880FF",
    fillOpacity: 0.35
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.0007,
    cy: 37,
    rx: 7,
    ry: 8,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0007 56C54.0007 60.4183 48.1804 59 41.0007 59C33.821 59 28.0007 60.4183 28.0007 56C28.0007 51.5817 33.821 46 41.0007 46C48.1804 46 54.0007 51.5817 54.0007 56Z",
    fill: "#4880FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5005,
    cy: 36,
    rx: 5.5,
    ry: 6,
    fill: "#4880FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5005,
    cy: 36,
    rx: 5.5,
    ry: 6,
    fill: "#4880FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2561 46.1207C66.4182 49.371 65.3653 52.4536 60.6848 54.1269C56.0044 55.8002 56.531 52.9058 55.369 49.6555C54.207 46.4052 47.0881 45.7131 51.7685 44.0398C56.449 42.3665 64.0941 42.8704 65.2561 46.1207Z",
    fill: "#4880FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0202 46.1207C14.8582 49.371 15.9111 52.4536 20.5915 54.1269C25.272 55.8002 24.7453 52.9058 25.9074 49.6555C27.0694 46.4052 34.1883 45.7131 29.5079 44.0398C24.8274 42.3665 17.1822 42.8704 16.0202 46.1207Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClients);
export default __webpack_public_path__ + "static/media/total-clients.5979373e1d1f05ceb50b69599457190b.svg";
export { ForwardRef as ReactComponent };